const error = {
  'pos.tags.not.allowed': '产品库下有产品类无法删除',
  'pts.template.template.group.has.associate': '模板已被关联',
  'pts.template.layout.has.associate': '版式已被关联',
  'aux.module.attribute.name.exist': '收选片角色已存在',
  'pms.machine.code.has.associate': '机器码已关联',
  'aux.template.has.associate.composeSizeGroup': '当前模板已关联尺寸组无法设置为默认模板！',
  'aux.template.sku.already.associated.type': '已关联了该类型的模板！',
  'aux.theme.has.associate': '主题已被使用',
  'aux.theme.name.exist': '主题名称已存在',

  'crm.wx.user.unbound': '当前用户未绑定账号或没有登录访问权限，请先完成绑定再登录',
  'crm.vip.store.collectionAccount.invalid': '收款账号格式不正确,应为纯数字',
  'pms.sku.group.tong.code.not.exist.in.erp': 'erp不存在该通货编码',
  'pms.sku.group.sample.code.not.exist.in.erp': 'erp不存在该样品编码',
  'oms.order.refund.not.allowed': '不允许取消订单',

  'aux.template.no.single': '模板页不是单个，不能设为默认',
  'aux.template.not.exist': '收片选片模板不存在!',
  'aux.template.name.lack': '收片选片模板名称不能为空!',
  'aux.template.name.exist': '收片选片模板名称已存在!',
  'aux.template.id.lack': '收片选片模板id不能为空!',
  'aux.module.not.exist': '模板页不存在!',
  'aux.module.name.lack': '模板页名称不能为空!',
  'aux.module.info.id.lack': '模板页信息id不能为空!',
  'aux.module.info.content.length.invalid': '文本数量不满足最多限制，请确认。',
  'aux.module.info.type.lack': '信息类型不能为空!',
  'aux.module.info.value.lack': '数量/长度限制不能为空!',
  'aux.attach.type.lack': '归属类型不能为空!',
  'aux.module.name.exist': '模板页名称已存在!',
  'aux.module.id.lack': '模板页id不能为空!',
  'aux.module.info.name.exist': '模板页信息名称已存在!',
  'aux.module.info.not.exist': '信息类型不存在!',
  'aux.module.has.associate': '模板页已关联收片选片模板，无法删除!',
  'aux.module.info.has.associate': '模板页信息已关联模板页，无法删除!',
  'aux.template.has.associate': '收片选片模板已关联活动，无法删除!',
  'aux.template.associate.task.underway': '收片选片模板关联活动正在进行中，无法编辑!',
  'aux.module.info.change.lack': '模板页信息id不能为空!',
  'aux.module.info.name.lack': '模板页信息名称不能为空!',
  'aux.task.not.allowed': '选片/收片不允许操作。',
  'aux.task.not.exist': '选片/收片不存在。',
  'aux.task.customer.not.exist': '当前选片/收片客户不存在。',
  'aux.task.completed': '当前选片/收片活动已完成。',
  'aux.task.out.time': '当前选片/收片活动已过期。',
  'aux.task.name.not.exist': '当前活动简介不能为空。',
  'aux.task.type.not.exist': '当前活动类型不能为空。',
  'aux.task.limitperson.not.exist': '当前活动限制人数不能为空。',
  'aux.task.completed.not.exist': '当前活动是否完成不能为空。',
  'aux.task.template.id.not.exist': '当前活动模板不能为空。',
  'aux.task.date.not.exist': '当前活动开始/结束时间不能为空。',

  'crm.store.must.relation.salesman': '请先绑定业务!',
  'crm.complaints.type.has.associate': '投诉类型已被使用!',
  'crm.complaints.type.name.exist': '投诉类型已存在!',
  'crm.complaints.type.not.exist': '投诉类型不存在!',
  'crm.complaints.type.lack': '请选择投诉类型!',
  'geteway.forbidden': '没有访问权限，请联系管理员!',
  'geteway.validate.failed': '参数检验失败',
  'pms.sku.front.name.exist': 'sku前端显示名称以存在',
  'pms.sku.name.exist': 'sku名称已存在',
  'oms.order.refund.is.exist': '已申请，请勿重复申请',
  'oms.order.refund.refundamount.not.allowed': '金额不符合要求',
  'pms.category.name.exist': '此分类名已被使用',
  'pms.compose.area.exist': '合成区域存在',
  'pms.compose.area.not.exist': '合成区域不存在',
  'pms.compose.area.has.associate': '该合成区已使用，无法删除',
  'pms.dict.already.associate.spu': '该属性已使用,无法编辑或删除',
  'pms.dict.attr.exist': '该属性值色块已存在',
  'pms.theme.name.exist': '该主题名称已存在',
  'pms.compose.size.name.exist': '尺寸名称已存在',
  'pms.white.page.has.associate': '白页已使用，无法删除',
  'crm.special.role': '特殊角色无法更改',
  'crm.role.doAssign.store.error': '该手机号已注册为平台管理员，无法创建当前该角色用户!',
  'pms.theme.has.associate': '该主题已经使用，无法编辑或删除',
  'pms.sku.has.associate': '该产品已经使用，无法编辑或删除',
  'crm.name.exist.store': '该平台名称已被注册为平台!',
  'crm.role.code.exist': '该角色编码已存在',
  'pts.template.page.name.exist': '页码名称已存在',
  'pms.category.have.sub.category': '未选择最底层类',
  'pts.template.page.number.has.associate': '页码已使用，无法编辑或删除',
  'auth.forbidden': '没有权限,请联系管理员',
  'auth.query.currentUser.failed': '请先登录',
  'auth.token.expired': 'token过期',
  'auth.token.missing': 'token缺失',
  'auth.unauthorized': '暂未登录或登录凭证已经过期，请重新登录!',
  'biz.failed.created.bean': '',
  'biz.not.implemented': 'Coming Soon! Expect Please!',
  'biz.service.instance.not.found': '',
  'biz.unexpected.internal.server.error': '',
  'crm.account.disabled': '该账号已被锁定，请联系管理员!',
  'crm.account.expired': '该账号已过期，请联系管理员!',
  'crm.account.locked': '该账户已被禁用，请联系管理员!',
  'crm.address.not.exist': '地址不存在!',
  'crm.address.over.limit': '地址数量超过10条，无法继续添加!',
  'crm.city.not.exist': '地市不存在!',
  'crm.code.difference': '验证码错误,请重新获取！',
  'crm.complaints.has.handle': '该投诉记录已处理!',
  'crm.complaints.not.exist': '投诉记录不存在!',
  'crm.credentials.expired': '该账户的登录凭证已过期，请重新登录!',
  'crm.error.phone.format': '手机号格式不正确,请重新输入!',
  'crm.forbidden': '没有访问权限，请联系管理员!',
  'crm.lack.address': '请选择完整的省市区地址!',
  'crm.lack.city.id': '地市id不能为空!',
  'crm.lack.city.name': '地市名称不能为空!',
  'crm.lack.code': '验证码不能为空!',
  'crm.lack.companyName': '公司名称不能为空!',
  'crm.lack.complaints.content': '投诉内容不能为空!',
  'crm.lack.confirmpassword': '确认密码不能为空!',
  'crm.lack.county.id': '区县id不能为空!',
  'crm.lack.county.name': '区县名称不能为空!',
  'crm.lack.full.address': '详细地址不能为空!',
  'crm.lack.fullName': '用户姓名不能为空!',
  'crm.lack.menu.name': '菜单名称不能为空!',
  'crm.lack.menu.pid': '父级菜单不能为空!',
  'crm.lack.menu.type': '菜单类型不能为空!',
  'crm.lack.password': '密码不能为空!',
  'crm.lack.person': '联系人不能为空!',
  'crm.lack.phone': '手机号不能为空!',
  'crm.lack.province.code': '省份code不能为空!',
  'crm.lack.province.name': '省份名称不能为空!',
  'crm.lack.role.id': '角色id不能为空!',
  'crm.lack.role.name': '角色名称不能为空!',
  'crm.lack.store.sendFlag': '发货目的地不能为空!',
  'crm.lack.store.typeid': '平台类型id不能为空!',
  'crm.lack.storeName': '平台名称不能为空!',
  'crm.lack.userId': '用户id不能为空!',
  'crm.lack.userType': '客户类型不能为空!',
  'crm.login.type.forbidden': '没有登录访问权限，请联系管理员!',
  'crm.menu.not.exist': '菜单不存在!',
  'crm.password.difference': '两次密码输入不一致，请重新输入!',
  'crm.phone.code.expired': '验证码错误,请重新获取！',
  'crm.phone.code.has.send': '验证码已发送，请耐心等待!',
  'crm.phone.code.send.failed': '验证码发送失败，请稍后重试!',
  'crm.phone.exist.store': '该手机号已被注册为平台!',
  'crm.phone.exist.user': '该手机号已被注册为用户!',
  'crm.phone.notice.send.failed': '短信提醒发送失败!',
  'crm.phone.message.send.over.limit': '手机号接收超过频率限制!',
  'crm.pmenu.not.exist': '父级菜单不存在!',
  'crm.province.not.exist': '省份不存在!',
  'crm.pwd.invalid': '密码必须包含大小写字母以及数字，长度必须大于8位，小于等于16位！',
  'crm.register.failed': '注册失败!',
  'crm.role.exist.user': '该角色已分配用户，无法编辑或删除!',
  'crm.role.not.exist': '角色不存在!',
  'crm.salesman.lack.id': '业务ID不能为空!',
  'crm.salesman.not.exist': '业务不存在!',
  'crm.special.menu': '特殊菜单无法操作!',
  'crm.store.has.audit': '该平台已完成审核，无须重复审核!',
  'crm.store.not.exist': '平台不存在!',
  'crm.store.parent.not.exist': '上级平台不存在!',
  'crm.store.type.not.exist': '平台类型不存在!',
  'crm.store.type.not.modify': '平台类型不能修改!',
  'crm.translator.badclient': 'client值不合法!',
  'pts.template.group.name.over.length': '模板组名称超过长度限制，最多10个字!',
  'pts.template.label.over.length': '素材标签超过长度限制，最多5个字!',
  'pts.template.page.name.over.length': '页码名称超过长度限制，最多10个字!',
  'pms.bar.code.name.over.length': '码名称超过长度限制，最多10个字!',
  'crm.translator.invalid.authorization_code': '授权码无效!',
  // 'crm.translator.invalid.refresh_token': 'refresh token无效!',
  'crm.translator.invalid.scope': '不是有效的scope值!',
  'crm.translator.invalidgrant': '不支持该认证类型!',
  'crm.translator.login.failed': '登录失败',
  'crm.translator.redirect.mis_match': 'redirect_uri值不正确!',
  'crm.translator.unsupported.code': '不是合法的response_type值!',
  'crm.translator.username.password.error': '用户名或密码错误!',
  'crm.unauthorized': '暂未登录或登录凭证已经过期，请重新登录!',
  'crm.user.identity.abnormal': '用户身份异常，请重新登录!',
  'crm.user.logout.failed': '退出失败!',
  'crm.user.notfound': '用户不存在!',
  'crm.user.remove.token.error': '退出或修改密码移除token异常!',
  'crm.user.resetPwd.failed': '修改密码失败!',
  'crm.user.resetPwd.oldPwd.error': '输入的旧密码有误!',
  'crm.user.resetPwd.user.error': '你修改的不是你登录的账号!',
  'crm.store.name.over.length': '名称超过长度限制，最多20个字!',
  'crm.address.full.address.over.length': '详细地址超过长度限制，最多20个字!',
  'crm.address.full.address.invalid': '详细地址不允许有特殊字符!',
  'crm.user.fullname.over.length': '客户姓名超过长度限制，最多10个字!',
  'crm.user.is.salesman': '当前用户已经为业务，无需添加!',
  'crm.add.mallUser.user.type.error': '只能添加代理、普通用户、平台子管理员!',
  'crm.role.name.over.length': '角色名称超过长度限制，最多10个字!',
  'crm.role.remark.over.length': '角色描述超过长度限制，最多25个字!',
  'crm.update.user.type.error': '只能将用户类型修改为代理、普通用户、平台子管理员、平台总管理员!',
  'crm.user.type.error': '平台管理员/平台子管理员不允许变更为管理员账号!',
  'crm.util.notfound.token': '暂未登录，请重新登录!',
  'crm.validate.failed': '参数检验失败',

  failed: '数据有误，请联系管理员',

  'frwk.sentinel.auth.rule.err': '授权规则不通过',
  'frwk.sentinel.degrade.rule.err': '降级',
  'frwk.sentinel.flow.rule.err': '限流',
  'frwk.sentinel.hot.param.flow.rule.err': '热点参数限流',
  'frwk.sentinel.sys.rule.err': '系统规则（负载/...不满足要求）',
  'illegal.access': '非法访问',
  'oms.cart.cartid.not.exist': 'cartId不能为空',
  'oms.cart.channel.not.exist': '渠道不能为空',
  'oms.cart.is.out': '购物车项信息过时了',
  'oms.cart.item.exist': '当前购物车子项已存在',
  'oms.cart.item.not.exist': '当前购物车子项不存在',
  'oms.cart.memo.not.exist': '用户备注不能为空',
  'oms.cart.not.allowed': '当前购物车子项货品不存在',
  'oms.cart.not.exist': '当前购物车不存在',
  'oms.cart.not.found': '获取购物车失败',
  'oms.cart.productid.not.exist': '产品ID不能为空',
  'oms.cart.producttype.not.exist': 'productType不能为空',
  'oms.cart.quantity.not.allowed': '数量不符合规范',
  'oms.cart.skugroupid.not.exist': 'skuGroupId不能为空',
  'oms.cart.skus.not.exist': '上传货品sku不能为空',
  'oms.cart.storeid.not.exist': 'storeId不能为空',
  'oms.order.addressid.not.exist': 'addressId不能为空',
  'oms.order.cartitemids.not.exist': 'cartItemIds不能为空',
  'oms.order.channel.not.exist': '渠道不能为空',
  'oms.order.discount.exist': '该订单已申请特价',
  'oms.order.not.allowed': '非法操作',
  'oms.order.not.exist': '该订单不存在',
  'oms.order.payment.failure': '支付失败',
  'oms.order.payment.mode.not.allowed': '该支付方式暂不支持',
  'oms.order.payment.paid.repeat': '重复支付订单',
  'oms.order.payqrcodepayment.not.allowed': '不允许扫码支付',
  'oms.order.sku.is.not.sale': ' 该商品已下架',
  'oms.order.storeId.not.exist': 'storeId不能为空',
  'oms.order.userid.not.exist': 'customerId不能为空',
  'oms.orderdiscount.audit.not.allowed': '非法操作',
  'oms.orderdiscount.not.exist': '该订单申请不存在',
  'oms.order.settlement.apply.not.allowed': '该订单不能结算',
  'oms.xsky.bucket.not.exist': 'xsky 存储桶不存在',
  'pay.account.balance.insufficient': '帐户余额不足',
  'pay.account.balance.insufficient.forfree': '余额不足，请联系客服人员!',
  'pay.account.trade.failed': '帐户交易失败',
  'crm.vip.store.channelCustomer.lack': 'vip平台是否渠道客户不能为空!',
  'crm.vip.store.automaticPayment.lack': 'vip平台是否自动支付不能为空!',
  'crm.vip.store.channelCustomer.must.automaticPayment': 'vip平台渠道客户必须开启自动支付!',
  'crm.store.not.channelCustomer': '当前平台不是渠道客户!',
  'crm.store.not.opened.automaticPayment': '当前平台未开通自动支付!',
  'crm.vip.store.channelCustomer.lack.wxconfig': 'vip平台渠道客户需上传小程序配置信息!',
  'crm.appid.invalid': '小程序id由18位数字和字母随机组成!',
  'crm.wxsecret.invalid': '小程序密钥要求32个字符，由数字和大小写字母组!',
  'crm.appletName.invalid': '小程序名称长度在4-30个字符之间!',
  'pay.bankAccount.missing': '银行帐户不存在',
  'pay.charge.amountCharge.ueq.amountBank': '平账失败，请重新选择收款记录',
  'pay.charge.auditStatus.error': '充值状态不正确',
  'pay.charge.balancing.amount.error': '充值帐户余额不正确',
  'pay.chargeStat.missing': '充值统计不存在',
  'pay.config.value.invalid': '配置无效',
  'pay.failed': '支付失败',
  'pay.gateway.error': '支付网关错误',
  'pay.tradeStatus.error': '支付网关错误',
  'pay.handle.paid.failed': '处理支付流程失败',
  'pay.paid': '交易已支付',
  'pay.param.body.isnull': '入参swiftpass.body不能为空值',
  'pay.param.charge.amount.mismatch': '充值金额不匹配',
  'pay.param.charge.auditStatus.error': '入参charge.auditStatus不正确',
  'pay.param.notifyUrl.isnull': '入参notifyUrl不能为空值',
  'pay.param.outTradeNo.isnull': '入参outOrderNo不能为空值',
  'pay.param.payChannel.isnull': '入参channel不能为空值',
  'pay.param.payType.isnull': '支付类型不能为空值',
  'pay.param.tradeMethod.isnull': '入参tradeMethod不能为空值',
  'pay.salesmanId.missing': '业务salesmanId缺失',
  'pay.sign.verify.failed': '签名验证失败',
  'pay.storeId.missing': 'storeId缺失',
  'pay.tradeAmount.mismatch': '交易金额不匹配',
  'pay.tradeMethod.mismatch': '交易方式不匹配',
  'pay.tradeNo.not.found': 'tradeNo缺失',
  'pay.tradeType.invalid': '交易类型无效',
  'pay.tradeType.mismatch': '交易类型不匹配',
  'pms.apply.exist': '该申请已存在',
  'pms.apply.not.exist': '该申请不存在',
  'pms.bar.code.has.associate': '已被关联，无法删除',
  'pms.bar.code.name.exist': '条码名称存在',
  'pms.bar.code.not.exist': '条码不存在',
  'pms.bleed.has.associate': '出血已使用，无法编辑或删除',
  'pms.bleed.name.exist': '出血名称存在',
  'pms.bleed.not.exist': '出血不存在',
  'pms.category.already.associate.spu': '当前类已关联产品',
  'pms.category.duplicate.name': '重复的类名',
  'pms.category.is.final': '重复的类名',
  'pms.category.not.allow.delete.top': '不允许删除最顶级类',
  'pms.category.not.exist': '类不存在',
  'pms.category.not.final': '当前类有子类',
  'pms.category.not.final.category': '当前二级类不是最底层类',
  'pms.compose.group.associate.duplicate.size': '尺寸组关联了重复的尺寸',
  'pms.compose.group.category.has.associate': '尺寸组类已使用',
  'pms.compose.group.category.name.exist': '尺寸组类名称存在',
  'pms.compose.group.category.not.exist': '尺寸组类不存在',
  'pms.compose.group.has.associate': '尺寸组已使用',
  'pms.compose.group.name.exist': '尺寸组名称存在',
  'pms.compose.group.not.exist': '尺寸组不存在',
  'pms.compose.size.exist': '合成尺寸已存在',
  'pms.compose.size.has.associate': '合成尺寸已使用，无法删除',
  'pms.compose.size.not.exist': '合成尺寸不存在',
  'pms.cut.line.exist': '合成区类型存在',
  'pms.cut.line.has.associate': '合成区类型已使用，无法删除',
  'pms.cut.line.not.exist': '合成区类型不存在',
  'pms.dict.already.assocaite.category': '属性已经关联类',
  'pms.dict.already.assocaite.sku': '属性已经关联SKU',
  'pms.dict.already.assocaite.spu': '属性已经关联产品',
  'pms.dict.already.assocaite.subordinate': '属性已经关联下级',
  'pms.dict.not.allow.deleted': '属性不允许被删除',
  'pms.dict.not.exist': '属性不存在',
  'pms.dict.value.url.both.empty': '属性值和属性url不能同时为空',
  'pms.duplicate.dict': '重复的属性值',
  'pms.fav.exist': '该收藏已存在',
  'pms.fav.type.not.exist': '收藏方式不存在',
  'pms.final.category.not.exist': '底级类不存在',
  'pms.json.format.error': 'json格式不正确，数据解析失败',
  'pms.page.name.associate.duplicate.property': '页面名称关联了重复的模版性质',
  'pms.page.name.exist': '页面名称已存在',
  'pms.page.name.has.associate': '页面名称已使用，无法编辑或删除',
  'pms.page.name.not.exist': '页面名称不存在',
  'pms.page.type.has.associate': '页面类型已使用，无法编辑或删除',
  'pms.page.type.name.exist': '页面类型名称存在',
  'pms.page.type.not.exist': '页面类型不存在',
  'pms.parent.dict.not.exist': '父属性不存在',
  'pms.property.has.associate': '产品性质已使用，无法编辑或删除',
  'pms.property.not.exist': '产品性质存在',
  'pms.qrcode.exist': '二维码已存在',
  'pms.qrcode.not.exist': '二维码不存在',
  'pms.sample.theme.not.exist': '样品主题不存在',
  'pms.sku.not.associate.aux.template': '未关联收选片模板',
  'pms.sku.not.associate.template': '未关联模板',
  'pms.sku.group.audit.status.error': 'sku组审核状态错误',
  'pms.sku.group.down.sale.error': 'sku组下架失败',
  'pms.sku.group.name.exist': 'sku组名字存在',
  'pms.sku.group.not.allow.delete': 'sku组不允许被删除',
  'pms.sku.group.not.allow.edit.status': '未审核的SKU组无法上架',
  'pms.sku.group.not.allow.update': 'sku组不允许被修改',
  'pms.sku.group.not.exist': 'sku组不存在',
  'pms.sku.group.on.sale.error': 'sku组上架失败',
  'pms.sku.group.parent.error': 'sku组父级错误',
  'pms.sku.group.sale.status.error': 'sku组sale状态码错误',
  'pms.sku.group.sample.not.exist': 'sku组样品主题不存在',
  'pms.sku.group.size.not.exist': 'sku组合成尺寸不存在',
  'pms.sku.not.allow.edit.status': 'sku不允许修改状态',
  'pms.sku.not.allow.update': 'sku上架时不允许被修改',
  'pms.sku.not.exist': 'sku对象不存在',
  'pms.sku.sample.title.name.exist': 'sku样品主题存在',
  'pms.sku.base.step.price.not.single': '增加一次平台价格应为0',
  'pms.sku.online.base.step.price.not.single': '增加一次在线支付平台价格应为0',
  'pms.sku.terminal.step.sale.price.not.single': '增加一次推荐终端价格应为0',
  'pms.sku.base.page.price.not.single': '基础P平台价格不唯一',
  'pms.sku.online.sale.price.not.single': '基础P在线支付价格不唯一',
  'pms.sku.terminal.sale.price.not.single': '基础P推荐终端价格不唯一',
  'pms.sku.lack.barCodePosition': '请选择条码位置',
  'wx.sku.price.not.single': '小程序产零售价格不唯一',
  'pms.special.price.less.min-store-price': '特殊价格不能低于最低平台价格',
  'pms.spu.name.exist': '产品名称已存在',
  'pms.spu.not.exist': '产品对象不存在',
  'pms.store.spu.name.exist': '产品名称已存在',
  'pms.store.spu.not.exist': '产品对象不存在',
  'pms.sub.category.error': '当前底层类和二级类不是从属关系',
  'pms.sub.category.not.exist': '二级类不存在',
  'pms.tag.exist': '标签已存在',
  'pms.tag.has.associate': '标签已使用，无法编辑或删除',
  'pms.tag.not.exist': '标签不存在',
  'pms.template.property.has.associate': '模版性质已使用，无法编辑或删除',
  'pms.template.property.name.exist': '模版性质名称存在',
  'pms.template.property.not.exist': '模版行之不存在',
  'pms.top.category.error': '当前二级类和顶级类不是从属关系',
  'pms.top.category.not.exist': '父级类不存在',
  'pts.template.add.group.error': '模板组创建失败',
  'pts.template.element.not.exist': '元素|背景|组合不存在',
  'pts.template.group.has.audit': '该模板组已完成审核，无须重复审核!',
  'pts.template.group.name.exist': '模板组名称已存在',
  'pts.template.group.text.page.num.less.sku.max.page': '模板页数量应大于等于sku最大P数',
  'pts.template.group.not.exist': '模板组不存在',
  'pts.template.label.exist': '素材标签已存在',
  'pts.template.label.exist.element': '该标签已使用，无法编辑或删除!',
  'pts.template.label.not.exist': '素材标签不存在',
  'pts.template.lack.element.images': '素材不能为空',
  'pts.template.lack.element.label': '元素|背景|组合 id不能为空',
  'pts.template.lack.label': '素材标签不能为空',
  'pts.template.lack.layout.label': '未选择版式',
  'pts.template.lack.template.id': '模板id不能为空',
  'pts.template.layout.not.exist': '版式不存在',
  'pts.template.template.has.used': '模板页已被使用，无法删除!',
  'pts.template.template.not.exist': '模板不存在',
  success: '操作成功!',
  'sys.current.user.not.belongTo.thus.store': '',
  'sys.store.mismatch': '平台不匹配',
  'sys.store.not.found': '平台不存在',
  'sys.user.not.found': '用户不存在',
  'pms.white.page.name.exist': '名称已存在',
  'pos.tags.name.exist': '产品库已存在',
  'pos.category.have.sub.category': '该类下有子类请先删除子类！',
  'pos.category.already.associate.spu': '该类已被使用禁止删除！',
  'finance.duplicate.name.or.code': '名称或编码重复',
  'finance.duplicate.name.or.shortName': '商品名称或简称已存在',
  'pms.discount.activity.name.exist': '活动名称不能重复',
  'pms.discount.lack.activity.name': '请输入活动名称',
  'pms.discount.lack.activity.type': '请选择活动类型',
  'pms.discount.lack.activity.dateStart': '请选择活动开始时间',
  'pms.discount.lack.activity.dateEnd': '请选择活动结束时间',
  'pms.discount.lack.activity.ladderDiscounts': '请选择活动阶梯优惠',
  'pms.discount.lack.activity.activityScope': '请选择各自满减或者混合满减',
  'pms.discount.lack.activity.isSameAddress': '请确认是否要求收货地址相同',
  'pms.discount.lack.activity.rule': '请填写阶梯满减规则',
  'pms.discount.lack.spu.id': '请选择参与满减活动的产品',
  'pms.discount.full.amount.invalid': '下一层级的【满额】需要大于上一个层级的【满额】',
  'pms.discount.full.piece.invalid': '下一层级的【满件】需要大于上一个层级的【满件】',
  'pms.discount.discount.amount.invalid': '下一层级的【优惠力度】要大于上一个层级的【优惠力度】',
  'pms.discount.spu.participated.in.other.activity': '产品已参加其他活动',
  'pms.discount.activity.not.exist': '满减活动不存在！',
  'pms.discount.lack.activity.id': '请正确选择要编辑的活动！',
  'pms.discount.spu.participate.over.limit': '添加参与活动的产品，超过上限',
  'pms.discount.activity.status.not.allow.update': '当前状态不允许编辑活动信息',
  'pms.discount.activity.discount.greater.than.product.price': '优惠力度大于产品价格',
  'pms.free.shipping.area.not.set': '包邮地区未设置！',
  'pms.express.module.id.is.null': '模板id为空！',
  'pms.express.module.is.null': '快递模板不存在！',
  'pms.fee.area.not.set': '运费计算地区未设置！',
  'pms.fee.least.one.exites': '至少存在一种计费方式！',
  'pms.fee.module.exites': '该运费模版已存在！',
  'pms.fee.address.exites.same': '存在相同的运费地区！',
  'pms.module.update.banner.name.exist': '名称已被占用，另起一个吧',
  'pms.banner.is.not.hava.enable.data': 'banner列表数据不存在',
  'crm.app.update.version.is.exist': '版本号已经存在！',
  'pms.recommend.product.is.not.hava.data': '模块数据不存在！',
  'crm.app.push.prod.exist': '该产品已经发送过上新通知，请勿重复发送！',
  'crm.app.customer.name.is.exist': '客服名称重复，请重新填写客服名称',
  'crm.app.customer.is.not.exist': '未查询到该客服信息',
  'crm.app.push.up.system.version.format.error': '系统版本格式错误',
  'crm.app.push.content.repeat': '消息内容不能重复',
  'crm.app.push.prod.title.name.repeat': '消息名称不能重复',
  'pms.app.has.associate.banner': '已关联首页banner，无法进行下架或删除操作！',
  'pms.app.has.associate.recemend': '已关联推荐产品，无法进行下架或删除操作！',
  'crm.app.system.version.is.error': '当前系统版本低于历史版本',
  'crm.app.system.up.sys.time.is.error': '当前升级版本更新时间小于历史版本更新时间',
  'crm.app.system.version.is.exist': '当前系统版本已存在',
  'crm.salesman.exist.associate.store': '当前业务存在关联平台!',
  'pms.compose.display.size.name.exist': '显示尺寸名称存在',
  'pms.compose.display.size.not.exist': '显示尺寸不存在',
  'pms.compose.display.size.has.associate': '显示尺寸已被关联',
  'crm.phone.the.same.twice': '两次手机号一致，无需修改!',
  'pms.lack.compose.sizeName': '请输入名称',
  'crm.video.season.membership.not.supported.diy.applet': '当前店铺未开通定制小程序会员名权益',
  'videos.eason.member.ship.plan.save.error': '套餐保存失败',
  'videos.eason.member.ship.plan.name.is.null': '套餐名称不能为空',
  'videos.eason.member.ship.plan.name.exist': '套餐名称已存在',
  'videos.eason.member.ship.plan.price.is.null': '套餐价格不能为空',
  'videos.eason.member.ship.plan.price.compare.zero': '套餐价格不能小于0',
  'videos.eason.member.ship.plan.related.rights.details.cannot.be.empty': '关联权益详情不能为空',
  'videos.eason.member.ship.plan.membership.level.is.exist': '套餐等级不能重复',
  'videos.eason.member.ship.plan.free.plan.is.null': '是否为体验套餐不能为空',
  'videos.eason.member.ship.plan.free.plan.one': '体验套餐只能有一个',
  'videos.eason.member.ship.plan.apply.transaction.number': '交易单号重复',
  'videos.eason.member.ship.plan.apply': '当前平台已提交申请，审核中请等待',
  'pms.feedback.not.exist': '反馈投诉不存在',
  'videos.eason.member.ship.plan.apply.waiting.for.review': '当前平台已提交申请，审核中请等待',
  'store.apply.discount.is.exist': '当前店铺已申请过折扣',
  'store.apply.discount.is.not.exist': '当前店铺未申请过折扣',
  'store.apply.not.update': '申请记录已审核或已拒绝，无法修改',
  'store.apply.discount.review': '当前记录已审核，不能重复操作',
  'store.apply.discount.reason.must.filled.refusing': '拒绝原因不能为空',
  'store.apply.discount.store.id.not.null': '店铺ID不能为空',
  'store.apply.discount.not.allow.apply': '在未审核的折扣申请，不允许提交多次',
  'videos.eason.member.ship.plan.membership.not.exist': '影像季店铺信息不存在',
  'bridal.category.already.associate.spu': '当前类已关联产品',
  'crm.user.is.salesman.manager': '当前用户已经为业务主管，无需添加!',
  'crm.salesmanmanager.id.lack': '业务主管ID不能为空!',
  'crm.salesmanmanager.not.exist': '业务主管不存在！',
  'crm.user.is.salesman.not.set.manager': '不能将业务设置成业务主管!',
  'crm.user.type.error.manager': '只能将代理、普通用户、业务、后台管理员变更为业务主管!',
  'oms.order.urgent.failure': '订单加急失败。',
  'oms.order.urgent.not.allowed': '不允许加急订单',
  'pms.discount.package.auditing': '该店铺折扣礼包正在审核中，请等待审核',
  'pms.discount.package.exist': '该店铺已经存在生效的折扣礼包',
  'pms.discount.package.status.unknown': '未知的折扣礼包状态',
  'pms.discount.package.not.exist': '该店铺折扣礼包不存在',
  'pms.discount.package.expired': '该折扣礼包已失效,不允许修改',
  'pms.platform.not.allow.modify': '平台号不允许修改',
  'pms.discount.status.not.allow.modify': '折扣状态不允许修改',
  'pms.discount.status.not.allow.audit': '折扣状态不允许审核',
  'pms.discount.package.not.allow.expired': '当前状态不允许设为失效',
  'pms.discount.package.discount.less.than.one': '已享受平台折扣，不可享受毕业季折扣包',
  'platform.discount.is.exist': '该平台已关联毕业季折扣包，不可申请平台折扣。',
  'pms.spu.participated.discount.activity': '产品已参加满减活动',
  'pms.spu.applied.special.price': '产品已申请特殊价格',
  'pms.spu.enabled.discount.bundle': '当前平台已享受该产品的毕业季折扣包，不可申请特殊价格',
  'pms.spu.store.applied.special.price': '当前平台已享受sku组特殊价格优惠，不可申请平台折扣',
  'pts.template.lack.group.isAssociatedeSizeGroup': '是否关联尺寸组不能为空',
  'oms.skuId.mismatch': '主题内容和SKU不匹配',
  'videos.season.already.buy.plan': '您已经参加过该活动',
  'videos.season.cannot.purchase.package.lower.than.current.level': '不能购买低于当前等级的套餐',
  'videos.season.error.in.amount.calculation': '金额计算错误',
  'videos.season.no.valid.member.order.information.found': '未找到有效的会员信息',
  'videos.season.the.application.record.does.not.exist': '申请记录不存在',
  'videos.season.apply.has.reviewed': '当前记录已审核，不能重复操作',
  'videos.season.must.fill.in.reason': '拒绝时必须填写原因'
}
export default error
